import { useMemo } from "react";
import type { CheckoutItem, Event } from "../types";

interface GroupedBasketItem {
  eventId: string;
  event: Event | undefined;
  items: CheckoutItem[];
  totalPrice: number;
}

export function useGroupedBasketItems(
  basketItems: CheckoutItem[],
  eventMap: Record<string, Event>,
): Array<[string, GroupedBasketItem]> {
  return useMemo(() => {
    const grouped = basketItems.reduce(
      (acc, item) => {
        const eventId =
          item.eventItem?.eventId ??
          (item as { raceItem?: { eventId: string } }).raceItem?.eventId;
        if (!eventId) return acc;

        if (!acc[eventId]) {
          acc[eventId] = {
            eventId,
            event: eventMap[eventId],
            items: [],
            totalPrice: 0,
          };
        }

        acc[eventId].items.push(item);
        acc[eventId].totalPrice += item.unitPriceCents;

        return acc;
      },
      {} as Record<string, GroupedBasketItem>,
    );

    return Object.entries(grouped);
  }, [basketItems, eventMap]);
}

